import { ShopifyService } from './ShopifyService';
import { WalmartService } from './WalmartService';
import { WixService } from './WixService';
import { EbayService } from './EbayService';
import { EstyService } from './EstyService';
import { BigCommerceService } from './BigCommerceService';
export const platformService = {
    async fetchAllOrders(email) {
        const results = await Promise.allSettled([
            ShopifyService.searchOrders(email),
            WalmartService.searchOrders(email),
            WixService.searchOrders(email),
            EbayService.searchOrders(email),
            EstyService.searchOrders(email),
            BigCommerceService.searchOrders(email),
        ]);
        const getOrders = (result, name) => {
            // Handle the different result structure from Promise.allSettled
            if (result.status === 'fulfilled') {
                // Some services might return { data: { data: [...] } } (axios) or just [...]
                const payload = result.value?.data;
                const orders = Array.isArray(payload) ? payload : payload?.data || [];
                return orders.map((o) => ({ ...o, platform: name }));
            }
            else {
                console.error(`${name} fetch failed:`, result.reason);
                return [];
            }
        };
        console.log('Fetched orders from all platforms:', results);
        return [
            ...getOrders(results[0], 'Shopify'),
            ...getOrders(results[1], 'Walmart'),
            ...getOrders(results[2], 'Wix'),
            ...getOrders(results[3], 'Ebay'),
            ...getOrders(results[4], 'Etsy'),
            ...getOrders(results[5], 'BigCommerce'),
        ];
    },
};
